import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceString'
})
export class ReplaceStringPipe implements PipeTransform {

  transform(value: string): any {
    let tel: string;
    tel = value.replace(/ /gi, "");
    return tel;
  }

}
